<template>
  <section class="layout-container">
    <router-view />
    <div class="app-nav-box">
      <!-- <router-link :to="{name: 'home'}" class="item" :class="[$route.name === 'home' ? 'active':'']">
        <div class="img-box home"></div>
        <p>知识</p>
      </router-link>
			<router-link :to="{name: 'physical'}" class="item" :class="[$route.name === 'physical' ? 'active':'']">
        <div class="img-box physical"></div>
        <p>实物</p>
      </router-link> -->
      <router-link
        :to="{ name: 'selected' }"
        class="item"
        :class="[$route.name === 'selected' ? 'active' : '']"
      >
        <div class="img-box select"></div>
        <p>已选</p>
      </router-link>
      <router-link
        :to="{ name: 'user' }"
        class="item"
        :class="[$route.name === 'user' ? 'active' : '']"
      >
        <div class="img-box user"></div>
        <p>我的</p>
      </router-link>
    </div>
    <!-- <CouponActivity ref="couponActivity" /> -->

    <nr-promotion-dialog
      ref="PromotionDialog"
      title="恭喜您"
      message="已获得新榜有赚推广人资格，点击“前往参与”了解详情。"
      btnText="前往参与"
      @onConfirm="handleConfirm"
    />
  </section>
</template>

<script>
import CouponActivity from "@/components/CouponActivity";
import PromotionDialog from "@/components/promotionDialog";
import { setLocalStorage, getLocalStorage } from "@/utils";
import { getPopularizeAuthByType } from "@/api/promotion";

export default {
  components: {
    CouponActivity,
    [PromotionDialog.name]: PromotionDialog,
  },
  methods: {
    handleConfirm() {
      this.$router.push({
        name: "promotion",
      });
    },
  },
  mounted() {
    //this.$refs.couponActivity.loadData()
    //产品说把推广弹窗关掉 2020-09-21
    // const { name } = this.$route;
    // const isPromotionPopup = getLocalStorage('NR_PROMOTION_HOME_DIALOG'); //在首页每个用户只弹一次，这里弹过后记录在本地
    // getPopularizeAuthByType({type: 1}).then(res=>{
    //   if(res.success && res.data && res.data.status === 1) {
    //     if(!isPromotionPopup && (name === 'home' || name === 'physical')) {
    //       setLocalStorage('NR_PROMOTION_HOME_DIALOG', true)
    //       this.$refs.PromotionDialog.show()
    //     }
    //   }
    // })
  },
};
</script>

<style lang="scss">
.layout-container {
  padding-bottom: $app-nav-height;
}
.app-nav-box {
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: $app-nav-height;
  background-color: #fff;
  border-top: 1px solid $border-color-base;
  z-index: 9999;

  .item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 24px;
    color: #3e4040;
    transition: all 0.3s;

    .img-box {
      width: 48px;
      height: 48px;
      margin-bottom: 5px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;

      &.home {
        background-image: url("../assets/imgs/icon_nav_home.svg");
      }
      &.select {
        background-image: url("../assets/imgs/icon_nav_select.svg");
      }
      &.physical {
        background-image: url("../assets/imgs/icon_nav_physical.svg");
      }
      &.user {
        background-image: url("../assets/imgs/icon_nav_my.svg");
      }
    }
    &.active {
      color: $primary-color;

      .home {
        background-image: url("../assets/imgs/icon_nav_home_a.svg");
      }
      .select {
        background-image: url("../assets/imgs/icon_nav_select_a.svg");
      }
      .physical {
        background-image: url("../assets/imgs/icon_nav_physical_a.svg");
      }
      .user {
        background-image: url("../assets/imgs/icon_nav_my_a.svg");
      }
    }
  }
}
</style>